// extracted by mini-css-extract-plugin
export default {"uploadBoxWrapper":"upload_uploadBoxWrapper__3UvRy","uploadLinkText":"upload_uploadLinkText__9oHth"};